import styled from "styled-components";
import { OptionContainer } from "@evergis/ui";

export const FeatureCardPickLayerMenu = styled.div`
  display: flex;
  flex-direction: column;
  position: inherit;
  width: 18.25rem;
  box-sizing: border-box;
  padding: 0.5rem 0;

  ${OptionContainer} {
    & span {
      white-space: unset;
    }
  }
`;

export const FeatureCardPickLayerMenuOption = styled.span<{ isFaded?: boolean }>`
  opacity: ${({ isFaded }) => isFaded && 0.28};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
